import {
  Box,
  Card,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ShopS3PresignedCardImage from "../../../../../../components/ShopS3PresignedCardImage";
import {
  currencyFormat,
  currencyFormatNoDecimals,
} from "../../../../../../components/NewDetail/calculations/utils";

const CopingCap = (props) => {
  const { accessToken, copingCap } = props;
  if (!copingCap) return null;

  return (
    <Box {...props}>
      <Typography variant="h6">
        Coping Cap -{" "}
        {currencyFormatNoDecimals(Math.round(copingCap.totalSellPrice))}
      </Typography>

      <TableContainer component={Box} sx={{ marginTop: "8px" }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "150px" }}>Piece Name</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Stretch Out</TableCell>
              <TableCell align="right">Price Per Piece</TableCell>
              <TableCell align="right">Total Sell Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {copingCap.capPieces.map((piece, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {/* <ShopS3PresignedImageLink
                      linkText={piece.name}
                      s3Key={piece.image}
                      accessToken={accessToken}
                      notes={piece.notes}
                    /> */}
                  <ShopS3PresignedCardImage
                    width={100}
                    s3Key={piece.image}
                    accessToken={accessToken}
                  />
                </TableCell>
                <TableCell align="right">{piece.quantity}</TableCell>
                <TableCell align="right">{piece.stretchOut}</TableCell>
                <TableCell align="right">
                  {currencyFormat(piece.pricePerPiece ?? 0)}
                </TableCell>
                <TableCell align="right">
                  {currencyFormat(piece.totalSellPrice ?? 0)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CopingCap;
